import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "notification-warning",
  "use": "notification-warning-usage",
  "viewBox": "0 0 29 29",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 29 29\" id=\"notification-warning\">\n  <path d=\"M101.292,201.75h2.417v-9.667h-2.417Zm0-12.083h2.417v-2.415h-2.417ZM102.5,180A14.5,14.5,0,1,0,117,194.5,14.516,14.516,0,0,0,102.5,180Zm0,26.583A12.083,12.083,0,1,1,114.583,194.5,12.1,12.1,0,0,1,102.5,206.583Z\" transform=\"translate(117 209) rotate(180)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/notification-warning.svg
// module id = null
// module chunks = 